{
  "nav": {
    "home": "Hjem",
    "pick": "Valg",
    "leaderboard": "Sammenlagt",
    "profile": "Profil",
    "leagues": "Ligaer",
    "active_league": "Aktiv Liga"
  },
  "common": {
    "error_data": "Feil ved lasting av data.",
    "stage": "Etappe",
    "go": "GÅ",
    "back": "← Tilbake",
    "one_day_race": "Endagsritt",
    "tomorrow": "I morgen",
    "in_days_one": "I morgen",
    "in_days_many": "Om {{count}} dager",
    "in_days_other": "Om {{count}} dager",
    "at_hours": "Kl. {{hours}}",
    "loading": "Laster...",
    "confirm": "BEKREFT",
    "logout": "LOGG UT",
    "in_days": "Om {{count}} dager",
    "error_generic": "Det oppstod en feil.",
    "optional": "valgfritt",
    "tu": "DU",
    "error_title": "Feil",
    "send": "Send",
    "retry": "Prøv igjen",
    "load_error_title": "Kunne ikke laste dataene",
    "load_error_sub": "Sjekk tilkoblingen og prøv igjen.",
    "stale_data": "Data kan være utdaterte: viser lagrede data."
  },
  "home": {
    "participants": "deltakere",
    "section_results": "Siste resultater",
    "section_upcoming": "Kommende ritt",
    "social": "Følg oss på sosiale medier",
    "onboarding_next": "Neste →",
    "onboarding_start": "Begynn å spille →",
    "onboarding_rules": "Les reglene",
    "section_picks": "Valg som gjenstår",
    "no_races": "Ingen ritt å velge for øyeblikket",
    "other_picks_one": "ett valg til å gjøre →",
    "other_picks_many": "{{count}} flere valg å gjøre →",
    "other_picks_other": "{{count}} flere valg å gjøre →",
    "stage_results": "Sammenlagt",
    "tab_stage": "ETAPPE",
    "tab_gc": "SAMMENLAGT",
    "no_data": "Ingen data tilgjengelig",
    "onboarding_step1_title": "Velkommen til Virtua Cycling!",
    "onboarding_step1_body": "Fantasyspillet for profesjonell sykling.",
    "onboarding_step2_title": "Slik fungerer det",
    "onboarding_item1": "Velg rytterne dine — Før hver etappe velger du rytterne du satser på. Du har tid frem til start.",
    "onboarding_item2": "Tjen poeng — Rytterne dine får poeng basert på deres faktiske plassering i etappen og i sammendraget.",
    "onboarding_item3": "Opprett din liga — Konkurrer med andre deltakere etappe for etappe og klatre på sammenlagtlisten.",
    "onboarding_step3_title": "Du er klar!",
    "onboarding_step3_body": "Du er i Virtua Cycling League, den generelle ligaen der alle spiller. Les hele regelverket så du ikke går glipp av noe.",
    "kofi_cta": "Liker du appen? Spander en øl på oss!",
    "jersey_gc": "Ledertrøye sammenlagt",
    "jersey_pt": "Poengtrøye",
    "jersey_gm": "Fjelltrøye",
    "greeting": "Hei, {{name}}",
    "status_ready": "Valg bekreftet for neste etappe",
    "status_todo": "Du har ikke gjort valgene dine ennå",
    "retry": "Prøv igjen"
  },
  "pick": {
    "live_label": "LIVE",
    "pick_done": "Valg allerede gjort — du kan fortsatt endre dem",
    "no_pick_stage": "Ingen valg funnet for denne etappen.",
    "error_load": "Feil ved lasting av ritt.",
    "loading": "Laster...",
    "title": "Valg",
    "no_races_title": "Ingen ritt tilgjengelig",
    "no_races_sub": "Det er ingen ritt planlagt for øyeblikket. Kom tilbake snart!",
    "banned_title": "Ute av rittet",
    "banned_stages_one": "Du har gått glipp av 1 etappe",
    "banned_stages_many": "Du har gått glipp av {{count}} etapper",
    "banned_stages_other": "Du har gått glipp av {{count}} etapper",
    "banned_detail": "Du kan følge resultatene og valgene til de andre, men du kan ikke delta i denne utgaven.",
    "banned_message": "Vi sees neste gang!",
    "stage_finished": "Etappen er ferdig. Her er valgene som ble gjort.",
    "live_alert": "Ritt pågår — lag låst",
    "startlist_btn": "Startliste",
    "startlist_title": "Startliste",
    "startlist_search": "Søk startnummer eller navn",
    "startlist_dnf": "Utgått",
    "startlist_empty": "Startliste ikke tilgjengelig ennå",
    "tab_insert": "Registrering",
    "tab_summary": "Sammendrag",
    "start_list_title": "Startlisten er ikke klar ennå",
    "start_list_sub": "Deltakerlisten publiseres snart. Sjekk igjen senere.",
    "need_more_one": "Velg {{count}} rytter til.",
    "need_more_many": "Velg {{count}} ryttere til.",
    "need_more_other": "Velg {{count}} ryttere til.",
    "error_save": "Feil ved lagring.",
    "loading_riders": "Laster ryttere...",
    "draft_restored": "Utkast gjenopprettet",
    "draft_count_one": "1 rytter lagret lokalt",
    "draft_count_many": "{{count}} ryttere lagret lokalt",
    "draft_count_other": "{{count}} ryttere lagret lokalt",
    "draft_cancel": "Avbryt",
    "select_n_one": "Velg {{count}} rytter",
    "select_n_many": "Velg {{count}} ryttere",
    "select_n_other": "Velg {{count}} ryttere",
    "add_rider": "+ Legg til rytter ({{current}}/{{limit}})",
    "edit_selection": "Rediger valg",
    "apply_all": "Bruk valget på alle mine ligaer",
    "saved_for": "Lagret for: {{leagues}}",
    "flip_used": "Flip — brukt",
    "flip_available": "Flip — tilgjengelig",
    "flip_remove": "Fjern",
    "flip_abbinato": "{{rider}} tilknyttet slot {{slot}}",
    "flip_confirmed": "Flip er registrert for denne etappen. Ved poengberegning velges den beste av de to.",
    "flip_slot_label": "Hvilket slot skal flippen knyttes til?",
    "flip_confirm_btn": "Bekreft flip",
    "saving": "Lagrer...",
    "confirm_pick": "BEKREFT VALG {{current}}/{{limit}}",
    "select_riders": "Velg ryttere",
    "search_rider": "Søk etter rytter...",
    "no_rider_found": "Ingen rytter funnet",
    "compare_users": "Sammenlign brukere",
    "confirm": "Bekreft",
    "no_pick_found": "Ingen valg funnet.",
    "toast_multi_one": "Valg lagret for 1 liga",
    "toast_multi_many": "Valg lagret for {{count}} ligaer",
    "toast_multi_other": "Valg lagret for {{count}} ligaer",
    "toast_single": "Valg lagret!",
    "compare_with": "Sammenlign med {{names}}",
    "compare_default": "Sammenlign med andre brukere (maks {{max}})",
    "tap_to_change": "• trykk for å endre",
    "you": "(DU)",
    "matrix_hint": "Trykk på en rytter for å se hvem som har valgt ham",
    "user_col": "Bruker",
    "scout_title": "Speiderrapport",
    "scout_top_rider": "Mest valgte rytter",
    "scout_distribution": "Fordeling per slot",
    "scout_variety": "Ligaens variasjon",
    "scout_distinct": "Ulike valgte ryttere",
    "scout_identical": "Identiske lag",
    "scout_no_picks": "Gjør dine valg for å se hvor mange som har samme lag som deg",
    "loading_lineups": "Laster lag...",
    "collapse_all": "LUKK ALT",
    "expand_all": "UTVID ALT",
    "no_races": "Det er ingen ritt tilgjengelig for øyeblikket.",
    "add_rider_one": "+ Legg til rytter ({{current}}/{{limit}})",
    "duplicate_rider": "{{name}} er allerede brukt i en tidligere etappe!",
    "draft_count": "Du har {{count}} rytter(e) lagret lokalt",
    "toast_multi": "Valg lagret for {{count}} ligaer",
    "scout_chosen_by": "Valgt av: {{names}}",
    "scout_chosen_by_others": "Valgt av: {{names}} og {{count}} andre",
    "scout_sharing": "Deler...",
    "scout_share_btn": "Del speiderrapport",
    "scout_outsider": "Outsider",
    "scout_contrarian": "Modigste valg",
    "scout_slot": "SLOT {{n}}",
    "scout_players": "{{count}} spillere",
    "draft_unsaved_banner": "Valg ikke bekreftet — trykk på Bekreft for å lagre det",
    "draft_unsaved_title": "Valg ikke bekreftet",
    "draft_unsaved_body": "Du har et valg som ikke er lagret. Vil du bekrefte valget før du forlater?",
    "draft_exit": "Forlat uten å lagre",
    "draft_confirm_now": "Bli og bekreft",
    "share_all": "Alle",
    "current_league": "Nåværende liga",
    "duplicate_rider_reason": "Allerede brukt: {{name}}",
    "flip_saved": "Flip lagret!",
    "flip_deleted": "Flip fjernet.",
    "flip_add_rider": "+ Legg til flip-rytter (valgfritt)",
    "riders_count_one": "1 rytter",
    "riders_count_many": "{{count}} ryttere",
    "riders_count_other": "{{count}} ryttere",
    "riders_selected_one": "1 valgt",
    "riders_selected_many": "{{count}} valgt",
    "riders_selected_other": "{{count}} valgt",
    "search_user": "Søk etter bruker...",
    "tab_per_tappa": "Per etappe",
    "tab_matrice": "Rytternes tilstedeværelse",
    "matrix_select_riders": "Velg ryttere å følge (maks 5)",
    "no_picks_riepilogo": "Ingen valg funnet",
    "no_picks_riepilogo_sub": "Du har ikke gjort noen valg for dette rittet ennå.",
    "scout_avg_pct": "~{{pct}}% i gjennomsnitt",
    "scout_no_identical": "Ingen andre har samme lag som deg",
    "scout_identical_count_one": "1 spiller har samme lag som deg",
    "scout_identical_count_many": "{{count}} spillere har samme lag som deg",
    "scout_identical_count_other": "{{count}} spillere har samme lag som deg",
    "scout_share_dialog": "Speiderrapport — {{name}}",
    "share_hidden": "+ {{count}} ANDRE SPILLERE · ÅPNE APPEN",
    "no_picks_tabella": "Ingen laguttak sendt inn",
    "no_picks_tabella_sub": "Valgene til de andre spillerne vises her.",
    "flip_slot_arrow": "→ slot {{slot}}",
    "race_tag_pick": "VELG",
    "race_tag_live": "LIVE",
    "race_tag_done": "AVSLUTTET",
    "race_switcher_label": "Løp",
    "race_history": "Løpshistorikk",
    "race_group_next": "Kommende",
    "race_group_past": "Tidligere",
    "close": "Lukk",
    "prev_stage": "Forrige etappe",
    "next_stage": "Neste etappe",
    "stage_list_title": "Etapper",
    "matrix_chosen_by": "{{name}} · valgt av {{count}} av {{total}}",
    "matrix_clear": "Fjern valg",
    "matrix_chosen_by_a11y": "valgt av {{count}} av {{total}} spillere",
    "matrix_open_player": "Åpne {{name}}s valg",
    "sheet_chosen_by": "{{count}} av {{total}}",
    "sheet_shared": "Samme som deg",
    "sheet_unique": "Unikt valg",
    "share_label": "VALGENE",
    "share_most_picked": "MEST VALGT",
    "share_unique_picks": "UNIKE VALG",
    "share_unique_sub": "ryttere valgt av bare én",
    "scout2_title": "Scout",
    "scout2_originality": "DIN ORIGINALITET",
    "scout2_twin": "DIN TVILLING",
    "scout2_identical": "IDENTISKE VALG",
    "scout2_identical_sub": "spillere med samme valg",
    "scout2_bold": "Dristig",
    "scout2_balanced": "Balansert",
    "scout2_aligned": "På linje",
    "scout2_in_common": "{{count}} av {{total}} felles",
    "scout2_none": "Ingen",
    "scout2_popularity": "Ryttere etter popularitet",
    "scout2_tap_hint": "Trykk på en rytter for å utheve ham i tabellen",
    "scout2_your_picks": "Dine valg",
    "scout2_also_by": "Også valgt av {{names}}",
    "scout2_only_you": "Bare deg",
    "scout2_outsiders": "Outsidere",
    "finished_banner": "Løpet er ferdig · du er nr. {{pos}} med {{pts}} poeng",
    "finished_banner_nopos": "Løpet er ferdig",
    "finished_cta": "Tabell",
    "scout2_like_you": "Hvem som spilte som deg",
    "scout2_twins_card": "DINE TVILLINGER",
    "scout2_same_as_you": "{{count}} med ditt samme valg",
    "scout2_same_picks": "Samme valg",
    "scout2_group_count": "{{count}} spillere",
    "scout2_no_common": "Ingen ryttere felles med",
    "scout2_other_identical": "Andre identiske valg",
    "result_title": "Slik gikk det",
    "result_total": "Du fikk {{pts}} poeng",
    "result_pick_line": "spådd {{slot}}. · kom inn som {{rank}}.",
    "result_dnf": "ikke klassifisert",
    "result_best": "Din beste",
    "result_worst": "Kostet deg mest",
    "result_malus": "Vinneren ikke valgt",
    "result_bonus_top10": "Alle i topp 10",
    "result_bonus_top15": "Alle i topp 15",
    "result_winner": "Vinneren",
    "result_winner_owners": "valgt av {{count}} av {{total}}",
    "result_nobody": "Ingen hadde ham",
    "result_difference": "Gjorde forskjellen",
    "result_difference_sub": "de som hadde ham fikk i snitt {{delta}} poeng mot de andre",
    "result_flop": "Sank mange",
    "result_flop_sub": "de som hadde ham fikk i snitt {{delta}} poeng mot de andre",
    "rules_title": "Regler kort fortalt",
    "rules_1": "Én rytter per etappe, tre i tempo.",
    "rules_2": "En rytter kan ikke brukes to ganger i samme løp.",
    "rules_3": "Hopper du over bare én etappe, er du ute av løpet: du kan følge med, men ikke spille.",
    "rules_flip": "Flip: bare én gang per løp angir du en reserverytter; han teller i stedet for din rytter bare hvis han kommer bedre inn.",
    "profile_flat": "Flat",
    "profile_hilly": "Kupert",
    "profile_mountain": "Fjell",
    "profile_itt": "Tempo",
    "profile_ttt": "Lagtempo",
    "view_by_rider": "Per rytter",
    "view_by_player": "Per spiller",
    "tour_summary": "{{riders}} ryttere valgt av {{players}} spillere",
    "your_pick": "Ditt valg",
    "tour_your_result": "Ditt resultat",
    "tour_stage_winner": "Etappevinner",
    "stage_finished_banner": "Etappen er ferdig · du er nr. {{pos}} på etappen ({{gap}})",
    "share_label_stage": "ETAPPENS VALG",
    "share_distinct_riders": "ULIKE RYTTERE",
    "scout_t_position": "DU ER I",
    "scout_t_break": "UTBRUDDET",
    "scout_t_small": "EN LITEN GRUPPE",
    "scout_t_group": "FELTET",
    "scout_t_with": "med {{count}} spillere",
    "scout_t_alone": "bare deg",
    "scout_t_leader": "LEDEREN VALGTE",
    "scout_t_jerseys": "Trøyene: hva de valgte",
    "scout_t_breakaway": "I utbruddet",
    "closes_at": "Stenger {{when}}",
    "closes_in": "Stenger om {{time}}",
    "profile_title": "Høydeprofil",
    "profile_climbs": "Stigninger",
    "profile_coppi": "C = Cima Coppi",
    "profile_a11y": "Høydeprofil: {{km}} km, høyeste punkt {{max}} m, {{n}} hovedstigninger",
    "profile_sprint": "S = mellomsprint",
    "profile_tap_climb": "Trykk på en stigning for detaljer",
    "profile_sprint_bonus": "Sprint · bonus",
    "climb_base": "Fot",
    "climb_summit": "Topp",
    "climb_avg": "Gjennomsnittlig stigning",
    "climb_length": "Lengde",
    "profile_bonus": "B = bonuspunkt"
  },
  "join": {
    "back_home": "Tilbake til startsiden",
    "welcome": "Velkommen til ligaen!",
    "already_member": "Du er allerede medlem av denne ligaen.",
    "error": "Kunne ikke bli med i ligaen.",
    "joining": "Får tilgang til ligaen...",
    "success": "Tilgang gitt!"
  },
  "leaderboard": {
    "stage_cancelled": "Etappe {{n}} avlyst: teller ikke i klassementet",
    "loading": "Laster...",
    "no_result_title": "Ingen resultat",
    "no_result_sub": "Resultatene for dette rittet er ikke tilgjengelige ennå.",
    "gc_rank": "Sammenlagt",
    "team_no_data": "Ingen lagdata for denne etappen.",
    "team_title": "LAGSAMMENDRAG",
    "stage": "Etappe {{n}}",
    "general": "Sammenlagt",
    "stage_rank": "Etappesammendrag {{n}}",
    "no_data_title": "Data ikke tilgjengelig",
    "no_data_sub": "Sammendraget for denne etappen er ikke beregnet ennå.",
    "one_day_race": "Endagsritt",
    "title": "Sammenlagt",
    "no_data": "Ingen data tilgjengelig.",
    "share": "Del",
    "jersey_tempo": "Tid",
    "jersey_punti": "Poeng",
    "jersey_gpm": "Fjell",
    "tab_individual": "Individuelt",
    "tab_team": "Lag",
    "share_text": "{{name}}\n\n{{text}}\n\n{{site}}",
    "sharing": "...",
    "race_tag_live": "PÅGÅR",
    "race_tag_done": "AVSLUTTET",
    "race_tag_soon": "SNART",
    "leader_label": "I trøya",
    "lead_over_second": "{{gap}} til nr. 2",
    "winner": "Vinner",
    "sheet_total": "Totalt",
    "tie": "delt",
    "top10_count": "{{count}} i topp 10",
    "has_winner": "Har vinneren",
    "my_rank": "Din plassering",
    "counts_for_team": "Teller for laget",
    "not_counting": "Teller ikke",
    "share_label": "TABELL",
    "gap_above": "{{gap}} til nr. {{pos}}",
    "gap_below": "{{gap}} foran nr. {{pos}}",
    "trend_up": "Opp {{n}} plasser",
    "trend_down": "Ned {{n}} plasser",
    "trend_same": "Plassering uendret",
    "sheet_by_stage": "Etappe for etappe"
  },
  "leagues": {
    "albo": "Æresliste",
    "no_podio": "har ikke oppnådd noen pallplasseringer ennå.",
    "victories": "Seire",
    "second": "2. plass",
    "third": "3. plass",
    "races_count_one": "1 ritt",
    "races_count_many": "{{count}} ritt",
    "races_count_other": "{{count}} ritt",
    "player_a": "-- Spiller A --",
    "player_b": "-- Spiller B --",
    "draws_one": "1 uavgjort",
    "draws_many": "{{count}} uavgjorte",
    "draws_other": "{{count}} uavgjorte",
    "on_races_one": "av 1 ritt",
    "on_races_many": "av {{count}} ritt",
    "on_races_other": "av {{count}} ritt",
    "no_common": "Ingen felles ritt med resultater.",
    "settings": "INNSTILLINGER",
    "your_position": "Din posisjon",
    "stagionale": "Sesongsammendrag",
    "hide": "SKJUL",
    "show_all_one": "VIS ALLE (1 til)",
    "show_all_many": "VIS ALLE ({{count}} til)",
    "show_all_other": "VIS ALLE ({{count}} til)",
    "no_data": "Ingen data tilgjengelig ennå.",
    "head2head": "Direkte oppgjør",
    "races_count": "{{count}} ritt",
    "draws": "{{count}} uavgjort",
    "on_races": "av {{count}} ritt",
    "show_all": "VIS ALLE ({{count}} til)",
    "badge_empty_1": "Ingen merker ennå — æren venter på deg! 🚴",
    "badge_empty_2": "Ingen bragder ennå, men hvert ritt er en mulighet. 💪",
    "badge_empty_3": "Fortsatt ingen merker — store mestere starter fra bunnen. 🏅",
    "badge_empty_4": "Det første merket er alltid det vanskeligste. Vi er nesten der! ⚡",
    "gap_to_podium": "{{gap}} poeng fra pallen",
    "gap_to_prev": "{{gap}} poeng bak nr. {{pos}}",
    "lead_over_next": "+{{gap}} poeng foran nr. {{pos}}",
    "invite_title": "Spiller du alene?",
    "invite_body": "Inviter vennene dine til å spille sammen i denne ligaen.",
    "invite_cta": "Inviter venner",
    "pick_member": "Velg en spiller",
    "position_a11y": "Plassering {{pos}}",
    "load_error": "Kunne ikke laste ligaen.",
    "tab_standings": "Tabell",
    "tab_stats": "Statistikk",
    "tab_rivalry": "Utfordringer"
  },
  "league": {
    "member_count_one": "1 bruker i denne ligaen",
    "member_count_many": "{{count}} brukere i denne ligaen",
    "member_count_other": "{{count}} brukere i denne ligaen",
    "index_join": "Bli med",
    "index_create": "Opprett liga",
    "manage_title": "Administrer {{name}}",
    "err_name": "Skriv inn et navn",
    "err_password": "Skriv inn et passord",
    "err_creation": "Feil ved opprettelse",
    "create_title": "Opprett ny liga",
    "create": "Opprett liga",
    "privacy": "Personvern",
    "public": "Offentlig",
    "private": "Privat",
    "err_join": "Feil, eller du er allerede påmeldt",
    "join_title": "Bli med i en liga",
    "search_placeholder": "Søk etter navn...",
    "search": "Søk",
    "no_leagues_found": "Ingen liga funnet",
    "join_btn": "Bli med",
    "password_insert": "Skriv inn passordet:",
    "calendar_section": "Kalender",
    "calendar_desc_admin": "Administrer ligaens ritt",
    "calendar_desc_user": "Ritt i kalenderen",
    "manage": "Administrer",
    "view": "Vis",
    "calendar_title": "Ligakalender",
    "calendar_save_one": "Lagre kalender (1 ritt)",
    "calendar_save_many": "Lagre kalender ({{count}} ritt)",
    "calendar_save_other": "Lagre kalender ({{count}} ritt)",
    "races_selected_one": "1 ritt valgt",
    "races_selected_many": "{{count}} ritt valgt",
    "races_selected_other": "{{count}} ritt valgt",
    "deselect_all": "Fjern alle valg",
    "select_all": "Velg alle",
    "loading": "Laster...",
    "settings_section": "Ligainnstillinger",
    "settings_name": "Ligaens navn",
    "settings_save": "Lagre",
    "settings_autopick": "Automatisk valg",
    "settings_autopick_desc": "Hvis en bruker ikke gjør et valg, velger systemet den beste tilgjengelige rytteren fra forrige etappe.",
    "settings_team_race": "Lagritt",
    "settings_team_race_desc": "Aktiver lagmodus for denne ligaen.",
    "settings_team_size": "Maks. medlemmer per lag",
    "settings_scoring": "Poengberegning",
    "settings_scoring_best2": "Beste 2 — summen av de to beste",
    "settings_scoring_avg": "Gjennomsnitt av alle medlemmer",
    "settings_flip": "Flip",
    "settings_flip_desc": "Hver bruker kan angi en jokerrytter for en valgfri etappe. Ved poengberegningen velges automatisk den beste av fast rytter og flip. Kan kun brukes én gang per ritt.",
    "invite_section": "Invitasjonslenke",
    "invite_loading": "Laster...",
    "invite_copied": "Kopiert!",
    "invite_copy": "Kopier",
    "invite_share_btn": "Del",
    "members_section": "Medlemmer",
    "members_title_admin": "Medlemsadministrasjon",
    "members_title_user": "Ligaens medlemmer",
    "leaving": "Forlater...",
    "leave": "Forlat denne ligaen",
    "admin_badge": "Admin",
    "remove": "Fjern",
    "pick_admin_title": "Rette valg",
    "pick_admin_desc": "Rediger brukernes valg",
    "pick_admin_open": "Åpne",
    "pick_admin_save": "Lagre valg",
    "pick_admin_none": "— ingen —",
    "pick_admin_search": "Søk etter rytter eller nummer",
    "pick_admin_retired": "utgått",
    "pick_admin_saved2": "{{set}} valg satt, {{removed}} fjernet",
    "pick_admin_nochange": "Ingen endringer å lagre",
    "pick_admin_undo": "Angre siste korrigering",
    "pick_admin_undone": "Korrigering angret",
    "pick_admin_future": "Fjernet også {{n}} valg fra kommende etapper med samme rytter",
    "pick_admin_notify": "Varsle spillerne",
    "pick_admin_no_calendar": "Dette løpet er ikke i ligakalenderen: kan ikke lagres",
    "stats_section": "Statistikk",
    "stats_participation": "Deltakelse per etappe",
    "stats_title": "Deltakelsesstatistikk",
    "stats_no_data": "Ingen data tilgjengelig.",
    "stats_error": "Kunne ikke laste statistikken. Prøv igjen.",
    "team_loading": "Laster lag...",
    "team_section": "Lag",
    "team_cancel": "Avbryt",
    "team_create_btn": "+ Opprett lag",
    "team_locked": "Ritt pågår — lagendringer deaktivert",
    "team_create": "Opprett lag",
    "team_members_count_one": "1/{{max}} medlem",
    "team_members_count_many": "{{count}}/{{max}} medlemmer",
    "team_members_count_other": "{{count}}/{{max}} medlemmer",
    "team_invite_btn": "+ Inviter",
    "team_leave": "Forlat",
    "team_save": "Lagre",
    "team_pwd_hint": "La stå tomt for å gjøre offentlig",
    "team_pending": "Venter på svar",
    "team_invite_cancel": "Avbryt",
    "team_invite_section": "Inviter et medlem",
    "team_no_invitable": "Ingen medlemmer tilgjengelig å invitere.",
    "team_invite_action": "Inviter",
    "team_private_label": "\"{{name}}\" er privat:",
    "team_join_action": "Bli med",
    "team_empty": "Ingen lag ennå — vær den første til å opprette et!",
    "team_mine": "DITT",
    "team_join": "Bli med",
    "team_full": "Fullt",
    "team_members": "Medlemmer",
    "join": "Bli med",
    "calendar_save": "Lagre kalender ({{count}} ritt)",
    "invite_share": "Del",
    "races_selected": "{{count}} ritt valgt",
    "invite_desc": "Del denne lenken — den som klikker kommer rett inn i ligaen.",
    "invite_desc_pwd": "Del denne lenken — den som klikker kommer rett inn i ligaen med passordet allerede inkludert.",
    "member_count": "{{count}} brukere i denne ligaen",
    "team_members_count": "{{count}}/{{max}} medlemmer",
    "create_name_placeholder": "F.eks.: Pedalvennene",
    "create_password_placeholder": "Tilgangspassord",
    "calendar_saved": "Kalender lagret!",
    "err_name_empty": "Navnet kan ikke være tomt",
    "settings_saved": "Innstillinger lagret!",
    "pwd_public_placeholder": "La stå tomt for en offentlig liga",
    "invite_share_title": "Bli med i {{name}} på Virtua Cycling",
    "invite_share_message": "Bli med i ligaen \"{{name}}\" på Virtua Cycling!\n{{url}}",
    "invite_regen_confirm": "Generere lenken på nytt? Alle tidligere lenker slutter å fungere.",
    "invite_regenerating": "Genererer på nytt...",
    "invite_regen_btn": "Generer lenke på nytt (tilbakekaller tidligere)",
    "confirm_remove": "Fjerne {{name}} fra ligaen?",
    "member_removed": "{{name}} fjernet",
    "confirm_demote": "Vil du fjerne adminrettighetene til {{name}}?",
    "confirm_promote": "Vil du forfremme {{name}} til admin?",
    "demote_admin": "Fjern Admin",
    "promote_admin": "Admin",
    "pick_admin_saved": "{{count}} valg lagret!",
    "confirm_team_leave": "Forlate laget?",
    "confirm_kick": "Fjerne {{name}} fra laget?",
    "team_invite_sent": "Invitasjon sendt!",
    "team_pwd_saved": "Passord oppdatert!",
    "team_name_placeholder": "Lagnavn...",
    "team_rename_placeholder": "Nytt navn...",
    "team_newpwd_placeholder": "Nytt passord..."
  },
  "profile": {
    "nick_title": "Kallenavn",
    "theme_title": "Temapersonalisering",
    "theme_dark": "Mørkt",
    "theme_light": "Lyst",
    "lang": "Språk",
    "save_lang": "Lagre språk",
    "nick_success": "Kallenavn oppdatert!",
    "nick": "Kallenavn",
    "nick_placeholder": "Skriv inn kallenavn",
    "update_btn": "Oppdater",
    "pass": "Passord",
    "show_pass": "Vis passord",
    "update_pass": "Oppdater passord",
    "avatars_title": "Avatarer",
    "avatars": "Vis avatarer",
    "avatars_sub": "Slå det av hvis telefonen er treg: i stedet for avatarer ser du rytternes lagdrakter og spillernes navn. Avataren din på forsiden blir.",
    "notif_title": "Push-varsler",
    "my_leagues": "Mine ligaer",
    "members_count_one": "1 medlem",
    "members_count_many": "{{count}} medlemmer",
    "members_count_other": "{{count}} medlemmer",
    "default_badge": "STANDARD",
    "set_default": "Angi som standard",
    "leave": "Forlat",
    "settings": "Profilinnstillinger",
    "hi": "Hei",
    "intro": "her kan du administrere kontoen din.",
    "admin_panel": "Administrasjonspanel",
    "theme_sub": "Synkronisert på alle enhetene dine.",
    "lang_title": "Språk / Language",
    "security_title": "Tilgang og sikkerhet",
    "security_success": "Data oppdatert!",
    "notif_enabled": "Aktiver varsler",
    "notif_enabled_sub": "Aktiver eller deaktiver alle varsler",
    "notif_results": "Rittresultater",
    "notif_results_sub": "Varsel når resultatene publiseres",
    "notif_startlist": "Startliste",
    "notif_startlist_sub": "Varsel så snart startlisten er tilgjengelig",
    "notif_reminder": "Påminnelse om valg",
    "notif_reminder_sub": "Motta en påminnelse før valgene stenger",
    "notif_reminder_off": "Ingen påminnelse",
    "notif_reminder_no_pick": "Bare hvis jeg ikke har valgt ennå",
    "notif_reminder_always": "Alltid",
    "notif_saving": "Lagrer...",
    "notif_saved": "Preferanser lagret!",
    "notif_error": "Feil ved lagring",
    "nick_taken": "Kallenavn er allerede i bruk",
    "pass_min_length": "Passordet må være minst 6 tegn",
    "pass_mismatch": "Passordene stemmer ikke overens",
    "new_pass_placeholder": "Nytt passord",
    "league_default_updated": "Standardliga oppdatert!",
    "league_leave_confirm": "Er du sikker på at du vil forlate \"{{name}}\"?",
    "league_left": "Liga forlatt.",
    "confirm_password": "Bekreft passord",
    "avatar_title": "Din avatar",
    "avatar_jersey": "Trøye",
    "avatar_cap": "Caps",
    "avatar_glasses": "Briller",
    "avatar_cyclist": "Syklist",
    "avatar_patch": "Trøyemerke",
    "avatar_saved": "Avatar lagret!",
    "avatar_save_btn": "Lagre avatar",
    "rules": "Regelverk",
    "report_bug": "Rapporter et problem",
    "bug_sent": "Rapport sendt, takk!",
    "bug_placeholder": "Beskriv problemet...",
    "group_identity": "Identitet",
    "group_account": "Konto",
    "group_contact": "Kontakt oss",
    "group_danger": "Faresone",
    "change_pass": "Endre",
    "cancel": "Avbryt",
    "show_more": "Vis alle ({{count}} til)",
    "show_less": "Vis færre",
    "delete_confirm": "Er du sikker på at du vil slette kontoen din? Handlingen kan ikke angres, og alle dataene dine slettes permanent.",
    "delete_desc": "Slettingen er permanent og fjerner alle dataene, valgene, ligaene og innstillingene dine.",
    "delete_btn": "Slett kontoen min",
    "delete_league_owner": "Du har opprettet en liga med andre medlemmer: hvis du sletter kontoen, forsvinner den for alle. Kontakt oss for å overføre den, eller slett den først.",
    "replay_tour": "Se turen på nytt",
    "leave_feedback": "Gi tilbakemelding",
    "feedback_placeholder": "En idé, et forslag eller en kommentar: vi vil gjerne høre fra deg...",
    "feedback_sent": "Takk for tilbakemeldingen! 🙏",
    "rate_app": "Vurder Virtua Cycling ⭐"
  },
  "login": {
    "err_nickname": "Skriv inn et kallenavn",
    "err_nickname_taken": "Kallenavn er allerede i bruk",
    "register_ok": "Registration completed! Check your email and confirm your account before logging in.",
    "err_email": "Skriv inn e-posten din",
    "forgot_sent": "E-post sendt! Sjekk innboksen din.",
    "tagline": "Ta din plass i følgebilen.",
    "tab_login": "Logg inn",
    "tab_register": "Registrer",
    "forgot_hint": "Skriv inn e-posten din, så sender vi deg en lenke for å tilbakestille passordet.",
    "email": "E-post",
    "forgot_send": "Send lenke",
    "back": "← Tilbake til innlogging",
    "nickname": "Kallenavn",
    "password": "Passord",
    "btn_login": "LOGG INN",
    "btn_register": "REGISTRER",
    "forgot_pass": "Glemt passord?",
    "or": "eller",
    "google_login": "Logg inn med Google",
    "google_register": "Registrer med Google",
    "privacy_text": "Ved å fortsette godtar du vår",
    "privacy_link": "Personvernerklæring",
    "loading": "…"
  },
  "news": {
    "title": "NYHETER",
    "loading": "Laster...",
    "no_news": "Ingen nyheter tilgjengelig.",
    "pinned": "Fremhevet",
    "not_found": "Artikkel ikke funnet.",
    "open_external": "Åpne artikkelen på {{source}}",
    "disclaimer": "Overskrifter og lenker kommer fra eksterne kilder: Artiklene tilhører de respektive utgiverne.",
    "tab_unread_one": "{{count}} ny nyhet",
    "tab_unread_other": "{{count}} nye nyheter",
    "load_error": "Vi kunne ikke laste inn nyhetene."
  },
  "reset_password": {
    "title": "NYTT PASSORD",
    "subtitle": "Velg et nytt passord for kontoen din",
    "show_pass": "Vis passord",
    "loading": "Verifiserer lenke...",
    "success": "Passord oppdatert! Du blir omdirigert..."
  },
  "confirm": {
    "verifying": "Verifiserer...",
    "error": "Feil under bekreftelse.",
    "success": "E-post bekreftet! Du blir omdirigert...",
    "missing_params": "Manglende parametere i lenken.",
    "missing_params_detail": "Sørg for at du har klikket på riktig lenke fra e-posten din.",
    "critical_error": "Kritisk tilkoblingsfeil."
  },
  "notifications": {
    "title": "Varsler",
    "empty": "Ingen varsler ennå",
    "accept": "Godta",
    "refuse": "Avslå",
    "now": "Nå",
    "minutes_ago": "{{count}} min siden",
    "hours_ago": "{{count}}t siden"
  },
  "quiz": {
    "card_sub": "10 spørsmål om Tour de France — hvor mye vet du?",
    "loading": "Laster spørsmål...",
    "no_questions": "Ingen spørsmål tilgjengelig",
    "question_count": "Spørsmål {{current}} av {{total}}",
    "easy": "Lett",
    "medium": "Middels",
    "hard": "Vanskelig",
    "correct": "Riktig svar!",
    "wrong": "Feil. Svaret var: {{answer}}",
    "next": "Neste",
    "see_result": "Se resultat",
    "restart": "Spill på nytt",
    "result_excellent": "Du er en ekte sykkelekspert!",
    "result_good": "Utmerket kunnskap om Tour de France!",
    "result_average": "Grei kunnskap. Se flere ritt!",
    "result_poor": "Det er rom for forbedring — men det er derfor man sykler!"
  },
  "person": {
    "hint": "Velg hvordan avataren din ser ut: du ser den på startsiden.",
    "gender": "Kjønn",
    "man": "Mann",
    "woman": "Kvinne",
    "hair_short": "Kort",
    "hair_curly": "Krøllete",
    "hair_wavy": "Bølget",
    "hair_shaved": "Barbert",
    "hair_pixie": "Pixie",
    "hair_bob": "Bob",
    "headwear": "Hodeplagg",
    "wear_none": "Ingen",
    "wear_cap": "Caps",
    "wear_helmet": "Hjelm",
    "glasses": "Briller",
    "glasses_off": "Nei",
    "glasses_on": "Ja",
    "jersey": "Trøye",
    "jersey_vertical": "Vertikal",
    "jersey_horizontal": "Horisontal",
    "jersey_classic": "Klassisk",
    "jersey_diagonal": "Diagonal",
    "jersey_dots": "Prikker",
    "row_skin": "Hud",
    "row_hair": "Hår",
    "row_brow": "Øyenbryn",
    "row_iris": "Øyne",
    "row_wear": "Hodeplagg",
    "row_visor": "Skygge",
    "row_vents": "Ventilasjonsåpninger",
    "row_frame": "Brillestamme",
    "save": "LAGRE",
    "saved": "Avatar lagret",
    "save_error": "Feil ved lagring",
    "reset": "Tilbakestill",
    "reset_done": "Tilbakestilt",
    "tab_face": "Ansikt",
    "tab_hair": "Hår",
    "tab_gear": "Tilbehør",
    "tab_jersey": "Trøye",
    "row_lens": "Glass",
    "jersey_body": "Kropp",
    "jersey_sleeves": "Ermer",
    "jersey_band": "Bånd",
    "jersey_trim": "Krage og mansjetter",
    "view_mine": "Min avatar",
    "view_world_champion": "Regnbuetrøye",
    "world_champion_since": "Verdensmester i {{league}} siden {{date}}",
    "view_european_champion": "Europamestertrøye",
    "european_champion_since": "Europamester i {{league}} siden {{date}}",
    "view_worldcup_leader": "Verdenscuptrøye",
    "worldcup_leader_since": "Leder av tabellen i {{league}} siden {{date}}",
    "kits_show": "Show team kits (admin)",
    "kits_hide": "Hide team kits",
    "kits_hint": "Team jerseys imported from PCS: check colours and design. Kits are fixed in the database.",
    "kits_approx": "approximate",
    "kits_men": "Men",
    "kits_women": "Women",
    "kits_wt": "WorldTeam",
    "kits_pro": "ProTeam",
    "kits_tap": "tap a team to see its riders",
    "kits_no_riders": "No avatars for this team yet.",
    "avatar_edit": "Rediger avatar",
    "avatar_cut": "Frisyre",
    "avatar_hair": "Hår",
    "avatar_skin": "Hud",
    "avatar_beard": "Skjegg",
    "avatar_beard_none": "Ingen",
    "avatar_face": "Ansikt",
    "avatar_face_none": "Standard",
    "avatar_face_a": "Smalt",
    "avatar_face_b": "Kraftig",
    "avatar_face_c": "Ungt",
    "avatar_face_d": "Kantete",
    "avatar_face_e": "Modent",
    "avatar_face_f": "Smilende",
    "avatar_face_g": "Lukket smil",
    "avatar_brow": "Øyenbryn",
    "avatar_brow_0": "Normale",
    "avatar_brow_1": "Tynne",
    "avatar_brow_2": "Kraftige",
    "avatar_beard_light": "Lett",
    "avatar_hex": "Annen farge (#RRGGBB)",
    "avatar_save": "Lagre",
    "avatar_reset": "Tilbakestill",
    "avatar_undo": "Angre siste endring",
    "avatar_saved": "Lagret",
    "avatar_bad_hex": "Ugyldig farge: bruk #RRGGBB",
    "avatar_err": "Kunne ikke lagre",
    "avatar_beard_legend": "1 skygge · 2 bart · 3 kort · 4 full · 6 bart+hakeskjegg · 7 sirkel · 8 lett skjeggstubb",
    "hair_wavy_medium": "Middels bølget",
    "hair_receding": "Inntrukket hårlinje",
    "hair_messy": "Rufsete",
    "hair_buzz": "Veldig kort",
    "hair_curly_short": "Korte krøller",
    "hair_medium": "Skulderlangt",
    "hair_flip_off": "Normal side",
    "hair_flip_on": "Speilvendt",
    "hair_side_part": "Sideskill",
    "hair_slicked_back": "Bakoverstrøket",
    "hair_forward": "Fremover",
    "hair_high_line": "Høy hårlinje",
    "hair_wavy_short": "Kort bølget",
    "hair_curly_medium": "Mellomlange krøller",
    "hair_receding_short": "Kort med viker",
    "beard_stubble_light": "Lett skjeggstubb",
    "hair_long": "Langt",
    "hair_ponytail": "Hestehale",
    "hair_bun": "Knute",
    "hair_long_wavy": "Bølget",
    "hair_braid": "Flette",
    "beard": "Skjegg",
    "beard_none": "Ingen",
    "beard_stubble": "Skygge",
    "beard_moustache": "Bart",
    "beard_short": "Kort",
    "beard_full": "Full",
    "beard_goatee": "Bart og hakeskjegg",
    "beard_circle": "Sirkelskjegg",
    "beard_op_normal": "Normal",
    "beard_op_light": "Lett",
    "fringe": "Lugg",
    "fringe_off": "Uten",
    "fringe_on": "Med lugg"
  },
  "app_update": {
    "title": "Ny versjon klar",
    "body": "Start appen på nytt for å få de nyeste endringene.",
    "restart": "Start på nytt",
    "later": "Senere"
  },
  "avatar": {
    "invite_title": "Her er avataren din!",
    "invite_body": "Vi har laget en til deg: tilpass den slik du vil.",
    "invite_cta": "Tilpass",
    "invite_dismiss": "Lukk",
    "edit_a11y": "Tilpass avataren din"
  },
  "jersey_celebration": {
    "ok": "Fantastisk!"
  },
  "insight": {
    "you": "Med deg",
    "form": "Form",
    "never": "Aldri valgt av deg: det ville vært første gang.",
    "picked": "Ganger valgt",
    "avg_rank": "Snitt plassering",
    "avg_gap": "Snitt etterslep",
    "best": "Beste resultat",
    "dnf": "Utgåtte med deg",
    "last": "Siste gang",
    "retired": "utgått",
    "form_avg": "Snitt siste 5",
    "season_races": "Løp i sesongen",
    "top10": "Topp 10",
    "wins": "Seiere",
    "dnfs": "Utgåtte",
    "cat_1": "Flate etapper",
    "cat_2": "Fjelletapper",
    "cat_3": "Kuperte etapper",
    "last5": "Siste 5 resultater",
    "no_results": "Ingen resultater ennå denne sesongen.",
    "open_a11y": "Innsikt om {{name}}",
    "summary": "{{n}}× med deg · snitt {{rank}}.",
    "summary_never": "Aldri valgt av deg",
    "open": "Innsikt"
  },
  "badges": {
    "title": "Badges",
    "album_title": "Troféskap",
    "earned_of": "{{earned}} av {{total}} badges",
    "open_album": "Åpne troféskapet",
    "recent": "Sist opptjent",
    "next_goals": "Mål innen rekkevidde",
    "filter_all": "Alle",
    "filter_earned": "Opptjent",
    "filter_todo": "Gjenstår",
    "group_gt": "Grand Tours",
    "group_monuments": "Monumenter og klassikere",
    "group_picks": "Valgkunst",
    "group_consistency": "Jevnhet",
    "group_league": "Ligatabell",
    "group_social": "Sosialt",
    "group_meta": "Samling",
    "tier_1": "Bronse",
    "tier_2": "Sølv",
    "tier_3": "Gull",
    "tier_4": "Platina",
    "tier_special": "Milepæl",
    "secret_title": "Hemmelig badge",
    "secret_hint": "Finn det ut ved å spille.",
    "earned_on": "Opptjent {{date}}",
    "progress": "{{value}} av {{threshold}}",
    "rarity": "{{pct}} % av ligaen har den ({{n}} av {{m}})",
    "rarity_none": "Ingen har den ennå: du kan bli den første.",
    "seasons": "Opptjente sesonger: {{count}}",
    "complete": "Fullført",
    "locked": "Gjenstår",
    "player": "Spiller",
    "none_me": "Ingen badges ennå: neste løp er sjansen din.",
    "none_other": "{{name}} har ingen badges ennå.",
    "empty_filter": "Ingenting å vise med dette filteret.",
    "load_error": "Kunne ikke laste badges.",
    "not_enabled": "Badges er ikke aktive i denne ligaen ennå.",
    "fam": {
      "RE_GT": {
        "title": "Kongen av de store rundene",
        "desc": "Vunne Grand Tours: {{n}}"
      },
      "WIN_GIRO": {
        "title": "Giroens konge",
        "desc": "Vinn sammenlagtkonkurransen i Giro d'Italia"
      },
      "WIN_TOUR": {
        "title": "Tourens konge",
        "desc": "Vinn sammenlagtkonkurransen i Tour de France"
      },
      "WIN_VUELTA": {
        "title": "Vueltaens konge",
        "desc": "Vinn sammenlagtkonkurransen i Vuelta"
      },
      "GT_PODI": {
        "title": "Pallplasser i de store rundene",
        "desc": "Pallplasser i Grand Tours: {{n}}"
      },
      "GT_DAYS": {
        "title": "Dager i trøya",
        "desc": "Dager som leder av sammenlagt: {{n}}"
      },
      "FIRST_PINK": {
        "title": "Rosa trøye",
        "desc": "Ta ledelsen i sammenlagtkonkurransen i Giro d'Italia"
      },
      "FIRST_YELLOW": {
        "title": "Gul trøye",
        "desc": "Ta ledelsen i sammenlagtkonkurransen i Tour de France"
      },
      "FIRST_RED": {
        "title": "Rød trøye",
        "desc": "Ta ledelsen i sammenlagtkonkurransen i Vuelta"
      },
      "GT_GREEN": {
        "title": "Sprinternes konge",
        "desc": "Vunne poengkonkurranser i Grand Tours: {{n}}"
      },
      "GT_POIS": {
        "title": "Fjellenes konge",
        "desc": "Vunne bjergkonkurranser i Grand Tours: {{n}}"
      },
      "GT_STAGE_WINS": {
        "title": "Etappejeger",
        "desc": "Vunne etapper i Grand Tours: {{n}}"
      },
      "GT_WIRE": {
        "title": "Fra start til mål",
        "desc": "Led sammenlagt fra første til siste etappe og vinn Grand Touren"
      },
      "GT_COMEBACK": {
        "title": "Comeback",
        "desc": "Vinn en Grand Tour selv om du var utenfor topp 10 etter første uke"
      },
      "GT_TRIPLE_JERSEY": {
        "title": "Total triumf",
        "desc": "Vinn sammenlagt, poeng og fjell i samme Grand Tour"
      },
      "GT_HEARTBREAK": {
        "title": "Det harde slaget",
        "desc": "Du ledet kvelden før siste etappe, men vant ikke Grand Touren"
      },
      "TRIPLE_CROWN": {
        "title": "Triple Crown",
        "desc": "Vinn Giro, Tour og Vuelta"
      },
      "THE_DOUBLE": {
        "title": "The Double",
        "desc": "Vinn Giro og Tour samme år"
      },
      "RE_MONUMENTI": {
        "title": "Monumentenes konge",
        "desc": "Vunne Monumenter: {{n}}"
      },
      "WIN_SANREMO": {
        "title": "La Classicissima",
        "desc": "Vinn Milano–Sanremo"
      },
      "WIN_FIANDRE": {
        "title": "Flandern rundt",
        "desc": "Vinn Flandern rundt"
      },
      "WIN_ROUBAIX": {
        "title": "Nordens helvete",
        "desc": "Vinn Paris–Roubaix"
      },
      "WIN_LIEGI": {
        "title": "La Doyenne",
        "desc": "Vinn Liège–Bastogne–Liège"
      },
      "WIN_LOMBARDIA": {
        "title": "Løpet med de døde bladene",
        "desc": "Vinn Lombardia rundt"
      },
      "MONUMENTS_SWEEP": {
        "title": "Alle Monumentene",
        "desc": "Vinn alle 5 Monumentene"
      },
      "RE_DEL_NORD": {
        "title": "Nordens konge",
        "desc": "Vinn Flandern og Roubaix samme år"
      },
      "ARDENNES": {
        "title": "Ardenner-trippel",
        "desc": "Vinn Amstel, Flèche Wallonne og Liège samme år"
      },
      "DUE_MARI": {
        "title": "Løpet mellom de to havene",
        "desc": "Vinn Paris–Nice og Tirreno–Adriatico samme år"
      },
      "MODALITA_POGACAR": {
        "title": "Pogačar-modus",
        "desc": "Vinn alle 3 Grand Tours og alle 5 Monumentene"
      },
      "RE_CLASSICHE": {
        "title": "Klassikernes konge",
        "desc": "Vunne klassikere: {{n}}"
      },
      "RE_TAPPE": {
        "title": "Etappeløpenes konge",
        "desc": "Vunne etappeløp: {{n}}"
      },
      "WORLD_CHAMP": {
        "title": "Verdensmester",
        "desc": "Vinn linjeløpet i VM"
      },
      "EURO_CHAMP": {
        "title": "Europamester",
        "desc": "Vinn linjeløpet i EM"
      },
      "CRONOMAN": {
        "title": "Tempospesialist",
        "desc": "Vinn et tempoløp i VM eller EM"
      },
      "SOLO_WIN": {
        "title": "Solo Win",
        "desc": "Eneste i ligaen som valgte vinneren: {{n}}"
      },
      "PROFETA": {
        "title": "Profet",
        "desc": "Vinnende valg: {{n}}"
      },
      "FIUTO": {
        "title": "Nese for vinnere",
        "desc": "Vinnere valgt av få: {{n}}"
      },
      "LEAGUE_WINS": {
        "title": "Løpsvinner",
        "desc": "Vunne løp i ligaen: {{n}}"
      },
      "LEAGUE_PODI": {
        "title": "Fast pallgjest",
        "desc": "Pallplasser i ligaens løp: {{n}}"
      },
      "DEBUTTO": {
        "title": "Debut",
        "desc": "Spill ditt første løp"
      },
      "PRESENZE": {
        "title": "Oppmøte",
        "desc": "Spilte løp: {{n}}"
      },
      "SERIE": {
        "title": "På rad",
        "desc": "Spilte løp på rad: {{n}}"
      },
      "STAGIONE_PERFETTA": {
        "title": "Perfekt sesong",
        "desc": "Spill alle løpene i sesongen"
      },
      "LEADER_STAGIONE": {
        "title": "I føringen",
        "desc": "Løp avsluttet i teten av tabellen: {{n}}"
      },
      "CAMPIONE_LEGA": {
        "title": "Ligamester",
        "desc": "Avslutt sesongen som nummer 1 i tabellen"
      },
      "PODIO_LEGA": {
        "title": "Ligapall",
        "desc": "Avslutt sesongen på pallen i tabellen"
      },
      "TOP10_LEGA": {
        "title": "Topp 10",
        "desc": "Avslutt sesongen blant de 10 beste i tabellen"
      },
      "SCALATORE": {
        "title": "Klatrer",
        "desc": "Plasseringer vunnet i ett enkelt løp: {{n}}"
      },
      "AMMAZZAGIANTI": {
        "title": "Kjempedreper",
        "desc": "Løp avsluttet foran lederen av tabellen: {{n}}"
      },
      "ALBUM": {
        "title": "Album",
        "desc": "Opptjente badges: {{n}}"
      },
      "LEGGENDA": {
        "title": "Legende",
        "desc": "Opptjen alle badges"
      }
    },
    "celebration_one": "Ny badge!",
    "celebration_many": "{{n}} nye badges!",
    "celebration_more": "og {{n}} til",
    "share": "Del",
    "share_label": "BADGE OPPTJENT",
    "share_dialog": "Min badge: {{name}}",
    "share_text": "Jeg har opptjent badgen «{{name}}» på Virtua Cycling! {{site}}",
    "showcase_title": "Utvalgt",
    "showcase_hint": "Velg opptil 3 badges å vise frem. Velger du ikke, viser vi de sjeldneste du har.",
    "showcase_edit": "Rediger",
    "showcase_auto": "Automatisk",
    "showcase_save": "Lagre",
    "showcase_count": "{{n}} av 3 valgt",
    "showcase_err": "Valget kunne ikke lagres.",
    "showcase_a11y": "Dine utvalgte badges",
    "showcase_none": "Opptjen din første badge for å se den her.",
    "showcase_pick_empty": "Du har ingen badges å vise i vitrinen ennå.",
    "jerseys_title": "Trøyer fra Grand Tours",
    "jersey_pink": "Rosa trøye",
    "jersey_yellow": "Gul trøye",
    "jersey_red": "Rød trøye",
    "days_caption": "Dager i trøya",
    "section_jerseys": "Trøyer",
    "special_title": "Spesialtrøyer",
    "special_now": "I bruk nå",
    "trophy_sub": "Badges, trøyer og æresliste"
  },
  "rivalry": {
    "title": "Utfordringer",
    "intro": "Velg en motstander. Hvis vedkommende godtar, får den som ender foran den andre poenget fra det løpet. Hele ligaen ser hvordan det går.",
    "slots": "Sendte utfordringer: {{used}} av {{max}}",
    "limit_reached": "Du har sendt maksimalt antall utfordringer. Avbryt eller avslutt én for å sende en ny.",
    "no_candidates": "Det er ingen andre spillere å utfordre.",
    "challenge_cta": "Send en utfordring",
    "pick_title": "Hvem vil du utfordre?",
    "confirm_challenge": "Utfordre {{name}}? Vedkommende mottar forespørselen og kan godta eller avslå.",
    "sent": "Forespørsel sendt til {{name}}.",
    "accepted": "Du har godtatt utfordringen med {{name}}.",
    "incoming_title": "Mottatte forespørsler",
    "incoming_line": "{{name}} utfordrer deg",
    "accept": "Godta",
    "decline": "Avslå",
    "waiting_title": "Venter på svar",
    "waiting_line": "Venter på {{name}}",
    "cancel": "Avbryt",
    "mine_title": "Dine utfordringer",
    "league_title": "I ligaen",
    "ended_title": "Avsluttede utfordringer: {{count}}",
    "empty": "Ingen pågående utfordringer i ligaen. Send den første!",
    "vs": "mot",
    "score_a11y": "{{a}} til {{b}}",
    "last_point": "Siste poeng: {{name}} i {{race}}",
    "no_races": "Ingen løp ennå",
    "won_by": "Vunnet av {{name}}",
    "drawn": "Endte uavgjort",
    "detail_title": "Utfordring",
    "results_title": "Løp for løp",
    "no_results": "Ingen poeng delt ut ennå.",
    "point_to": "Poeng til {{name}}",
    "end_cta": "Avslutt utfordringen",
    "end_confirm": "Avslutte utfordringen med {{name}}?",
    "rematch": "Revansj",
    "load_error": "Kunne ikke laste utfordringene.",
    "err_limit": "Du har allerede sendt maksimalt antall utfordringer.",
    "err_exists": "Dere er allerede i en utfordring, eller en forespørsel pågår.",
    "err_invalid": "Denne forespørselen er ikke lenger gyldig.",
    "err_generic": "Handlingen kunne ikke fullføres.",
    "notif_accepted": "Utfordring godtatt",
    "notif_declined": "Utfordring avslått"
  },
  "competition": {
    "men": "Men Elite",
    "women": "Women Elite",
    "aria": "Konkurranse"
  },
  "no_league": {
    "title": "Du deltar ikke i noen {{comp}}-liga",
    "body": "Du kan bli med i en liga eller opprette en ny fra Ligaer.",
    "body_official": "Du kan bli med i den offisielle ligaen når du vil, eller bli med i eller opprette en privat liga fra Ligaer.",
    "join": "Bli med i {{name}}",
    "go_leagues": "Gå til ligaer"
  }
}
